<template>
  <div class="loading">
    <div class="gif">
      <img :src="$root.loadingImage?$root.loadingImage:'/images/loading_bk.gif'" :alt="$t('altTag',{
                      affiliate:$root.affiliate
                    })"/>
    </div>
  </div>
</template>
<script>
export default {
  name: "loading",
  methods: {
    handleStyles() {
      document.body.className = "body-scroll-hidden";
    }
  },
  beforeDestroy() {
    document.body.className = "";
  },

  // Handle styles when the app is initially loaded
  mounted() {
    this.handleStyles();
  }
};
</script>
<style lang="scss">
@import "style";
</style>